import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { authClient } from "@core/clients";
import { RegisterResponse, RegisterUserCredentials } from "@core/types";

const useRegisterVerificationCodeMutation = (
  options?: UseMutationOptions<RegisterResponse, any, RegisterUserCredentials>
) =>
  useMutation(
    ["register"],
    async (params) => {
      const data = await authClient.register(params);
      return data;
    },
    options
  );

export default useRegisterVerificationCodeMutation;
